(function() {
  var productsContainer = document.getElementById('MobileMenuProducts');

  if (!productsContainer || !window.fetch) return;

  function loadMobileMenuProducts() {
    if (productsContainer.dataset.state === 'loaded' || productsContainer.dataset.state === 'loading') return;

    productsContainer.dataset.state = 'loading';
    productsContainer.setAttribute('aria-busy', 'true');

    window.fetch(productsContainer.dataset.sectionUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load mobile menu products');
        return response.text();
      })
      .then(function(markup) {
        if (!markup || !markup.trim()) throw new Error('Mobile menu products were empty');

        productsContainer.innerHTML = markup;
        productsContainer.dataset.state = 'loaded';
        productsContainer.setAttribute('aria-busy', 'false');
      })
      .catch(function() {
        productsContainer.dataset.state = 'error';
        productsContainer.setAttribute('aria-busy', 'false');
      });
  }

  document.addEventListener('drawerOpen.NavDrawer', loadMobileMenuProducts);

  var menuSearch = document.querySelector('[data-mobile-menu-search]');

  if (!menuSearch || !window.theme || !theme.routes || !theme.routes.predictiveSearch) return;

  var searchInput = menuSearch.querySelector('[data-mobile-menu-search-input]');
  var searchResults = menuSearch.querySelector('[data-mobile-menu-search-results]');
  var clearSearchButton = menuSearch.querySelector('[data-mobile-menu-search-clear]');
  var searchDebounceTimer;
  var latestSearchRequest = 0;

  function clearSearchResults() {
    latestSearchRequest += 1;
    searchResults.innerHTML = '';
    searchResults.hidden = true;
    searchResults.setAttribute('aria-busy', 'false');
    searchInput.setAttribute('aria-expanded', 'false');
  }

  function renderSearchResults(searchTerm) {
    var requestId = ++latestSearchRequest;
    var searchParams = new URLSearchParams({
      q: searchTerm,
      'resources[type]': 'product',
      'resources[limit]': '4',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last'
    });

    searchResults.hidden = false;
    searchResults.setAttribute('aria-busy', 'true');
    searchResults.innerHTML = '<p class="mobile-menu-search__loading">Searching&hellip;</p>';
    searchInput.setAttribute('aria-expanded', 'true');

    window.fetch(theme.routes.predictiveSearch + '?' + searchParams.toString() + '&section_id=mobile-menu-search-results', { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to fetch search results');
        return response.text();
      })
      .then(function(markup) {
        if (requestId !== latestSearchRequest) return;

        var parsedMarkup = new DOMParser().parseFromString(markup, 'text/html');
        var section = parsedMarkup.querySelector('#shopify-section-mobile-menu-search-results');

        if (!section) throw new Error('Search results section was not returned');

        searchResults.innerHTML = section.innerHTML;
        searchResults.setAttribute('aria-busy', 'false');
      })
      .catch(function() {
        if (requestId !== latestSearchRequest) return;
        clearSearchResults();
      });
  }

  searchInput.addEventListener('input', function() {
    var searchTerm = searchInput.value.trim();
    clearSearchButton.hidden = searchTerm.length === 0;
    window.clearTimeout(searchDebounceTimer);

    if (searchTerm.length === 0 || menuSearch.dataset.predictiveEnabled === 'false') {
      clearSearchResults();
      return;
    }

    searchDebounceTimer = window.setTimeout(function() {
      renderSearchResults(searchTerm);
    }, 300);
  });

  clearSearchButton.addEventListener('click', function() {
    searchInput.value = '';
    clearSearchButton.hidden = true;
    clearSearchResults();
    searchInput.focus();
  });
})();
